export default "__VITE_ASSET__BXs2vAqY__"